import { render } from "./ModalMessageWindow.vue?vue&type=template&id=107c56e5&scoped=true"
import script from "./ModalMessageWindow.vue?vue&type=script&lang=js"
export * from "./ModalMessageWindow.vue?vue&type=script&lang=js"

import "./ModalMessageWindow.vue?vue&type=style&index=0&id=107c56e5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107c56e5"]])

export default __exports__